<template>
    <div>
       <div class="progress cstm_percentage_circle" v-if="percent>10">
          <PercentageCircle :percent="percent" size="large" active-color="blue" complete-color="green" :animate="true" />
        </div>
        <!-- Excel Pop Up -->
        <!-- //1st step     -->
        <file-upload
        v-if="firstStep"
        :module_id="module_id"
        @getFileInfo="getFileInfo"
        >
            
        </file-upload>
            

<div v-else>
    <!-- <div class="flex justify-between">
        <h3>Header</h3>
        <h3>Select Mapping Excel</h3>
    </div> -->
        <form data-vv-scope="excel">
    <div class="pb-2 flex justify-between staff_excel_holder mb-3"
    v-for="(eachHeading,index) in staffHeading" :key="index">
    <!-- <pre>{{eachHeading}}</pre> -->
      <div class="relative w-full">
        <label class="animated_label" :class="[focusedIndex == index || eachHeading.staff_heading? 'focused' : '']">{{eachHeading.field_label}}</label>
            <v-select
             :name="eachHeading.field_label"
            @search:focus="openselect(index)"
            class="w-100"
            v-model="eachHeading.staff_heading"
            :options="excelHeader"
            :selectable="option => !getSelectedHeading.includes(option)"

            ></v-select>
          <span v-show="errors.has(`excel.${eachHeading.field_label}`)" class="text-danger">{{ errors.first(`excel.${eachHeading.field_label}`) }}</span>

      </div>
<!-- <pre>{{staffHeading}}</pre> -->

    </div>
    <!-- {{getSelectedHeading}} -->
    <vs-button @click.prevent="finalImportExcel()">Save</vs-button>
        </form>
    <a 
    :href="errorFile"
    v-if="errorFile"
    download
    target="_blank"
    >Download error log</a>

</div>

                <!-- 2nd Step -->


    </div>
</template>
<script>
import PercentageCircle from 'vue-css-percentage-circle'
import FileUpload from '@/components/common/Excel/FileUpload.vue'
import {ExcelHeaderApi, getStaffDbHeaderApi, importExcelApi,ModuleheaderApi} from '@/api/excelApi'
import vSelect from 'vue-select'
export default {
  components:{
    FileUpload,
    vSelect,
    PercentageCircle
  },
  props: {
    module_id:{}
  },
  data () {
    return {
      percent: 10,
      firstStep:true,
      staffHeading:[],
      excelHeader:[],
      currentFilePath:'',
      current_file_id:null,
      errorFile:'',
      focusedIndex: null
    }
  },
  created () {
    this.getSTaffDbHeader()
  },
  computed:{
    getSelectedHeading () {
      return this.staffHeading.filter(ele => ele.staff_heading).map(ele => ele.staff_heading)
    }
  },
  watch: {
    errorFile () {
      if (this.errorFile !== '') {
        this.$emit('uploadSuccess', false)
      }
    }
  },
  methods:{
    openselect (i) {
      this.focusedIndex = i
      console.log(this.focusedIndex)
    },
    async finalImportExcel () {
       try{
      const result = await this.$validator.validateAll('excel')
      if (!result) {
        this.$vs.notify({
          title: 'Warning',
          text: 'All fields are required',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      } else {
      const mandatoryField = this.staffHeading.filter(ele => ele.enabled_parent).map(ele => ele.field_name)
      const mapFilter = this.staffHeading.filter(ele => {
        return  ele.staff_heading
      }).map(ele => ele.field_name)
      let checkingMandatory = true
      mandatoryField.forEach(ele => {
        if (!mapFilter.includes(ele)) {
          checkingMandatory = false
        }
      })
      if (checkingMandatory) {
        const payload = {}
        console.log('hoi')
        this.staffHeading.filter(ele => {
          return  ele.staff_heading
        }).forEach(ele => {
            
          payload[ele.field_name] = ele.staff_heading
        })
        console.log(payload)
        const columnspayload = {
          file_path:this.currentFilePath,
          id:this.current_file_id,
          columns:payload
        }
        this.finalImport(columnspayload)
      } else {
        this.showSuccessMessage('Error', `${mandatoryField} must map this value`, 'danger')
      }
      console.log(checkingMandatory)
      }
       }catch (error) {

      }
    },
    async finalImport (columnspayload) {

      try {
        this.percent =Math.floor(Math.random() * (parseInt(50) - parseInt(30) + 1)) + parseInt(30)
        const customer_id = localStorage.getItem('customer_id')
        const data = await importExcelApi('staff', customer_id, columnspayload)
        this.showSuccessMessage('Success', 'Excel Imported Successfully', 'success')
        this.$emit('uploadSuccess', true)
         this.percent = 100
        console.log(data)
         setTimeout(() => {
          this.percent = 0 
        },1000)
      } catch (error) {
        this.percent = 0
        console.log(error.data.data.error_file)
        this.showSuccessMessage('Error', error.data.message, 'danger')
        
        this.errorFile = error.data.data.error_file
        console.log(error.data)
      }
    },
    getFileInfo (filesInfo) {
      if (filesInfo) {
        this.firstStep = false
        this.current_file_id = filesInfo.id
        this.currentFilePath = filesInfo.file_path
        this.getHeader(filesInfo.file_path)
      }
      console.log(filesInfo)
    },
    async getHeader (file_path) {
      const fileObject = {
        file_path
      }
      console.log(file_path)
      const customer_id = localStorage.getItem('customer_id')
      const {data} = await ExcelHeaderApi(customer_id, fileObject)
      this.excelHeader = data.data.headings
       this.staffHeading.forEach(ele => {
        
           if(this.excelHeader.includes(ele.field_label))
           {
             ele['staff_heading']=ele.field_label
           }
         })
      console.log(data)
    },
    async getSTaffDbHeader () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await ModuleheaderApi(customer_id, 'staff')
        console.log(data.data)
        this.staffHeading = data.data
        this.staffHeading = this.staffHeading.map(ele => {
          return {
            ...ele,
            staff_heading:''
          }

        })
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>